import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { addUrlProps, UrlQueryParamTypes, multiPushInUrlQuery, Serialize } from 'react-url-query';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import SearchNav from '../searchNav/SearchNav';
import MultiNutrientQueryBuilder from './MultiNutrientQueryBuilder';
import MultiNutrientResult from './MultiNutrientResult';
import { getValidCodes, getValidGroup } from '../../util/util';
import PrintHeader from '../../presentation/Print/PrintHeader';
import PrintDisclaimer from '../../presentation/Print/PrintDisclaimer';

const urlPropsQueryConfig = {
  code: { type: UrlQueryParamTypes.string },
  group: { type: UrlQueryParamTypes.string },
  page: { type: UrlQueryParamTypes.number },
  size: { type: UrlQueryParamTypes.number },
  sort: { type: UrlQueryParamTypes.string },
  order: { type: UrlQueryParamTypes.string },
  per100g: { type: UrlQueryParamTypes.boolean },
};

const handleSubmit = function(query) {
  // onChangeXXX does not push history. use multiPushInUrlQuery.
  // size and per100g stays the same on new search
  multiPushInUrlQuery({
    code: query.code,
    group: query.group,
    page: '',
    sort: '',
    order: '',
  });
};

const handlePageChange = function(newPage, newSize) {
  multiPushInUrlQuery({
    page: newPage,
    size: newSize,
  });
};

const handleSortChange = function(newSortName, newSortOrder) {
  multiPushInUrlQuery({
    sort: newSortName,
    order: newSortOrder,
    page: '',
  });
};

const handlePerChange = function(newPer100g) {
  multiPushInUrlQuery({
    page: '',
    per100g: newPer100g === true ? Serialize.encodeBoolean(newPer100g) : '',
  });
};

/**
 * Concerns of this component:
 *   control url query
 *   fetch /component
 *   fetch /food/group
 *   validate 'code' and 'group' from url query
**/
class MultiNutrientSearch extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  render() {
    const { componentFetch, groupFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([componentFetch, groupFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([components, groups]) {
    let validCodes = getValidCodes(this.props.code, components);
    // limit number of codes up to 3.
    if (validCodes.length > 3) {
      validCodes = validCodes.splice(0, 3);
    }
    const validGroup = getValidGroup(this.props.group);
    const validPer100g = this.props.per100g ? true : false;

    return (
      <div className="MultiNutrientSearch">
        <Helmet title="Multi-Nutrient Search - New Zealand Food Composition Database" />

        <PrintHeader title='MULTI-NUTRIENT SEARCH' />

        <SearchNav currentPath={this.props.match.url}>
          <MultiNutrientQueryBuilder
            components={components}
            groups={groups}
            selectedComponents={validCodes}
            selectedGroup={validGroup}
            handleSubmit={handleSubmit} />
        </SearchNav>

        {validCodes.length > 0 &&
          <MultiNutrientResult
            handlePageChange={handlePageChange}
            handleSortChange={handleSortChange}
            handlePerChange={handlePerChange}
            components={components}
            groups={groups}
            codes={validCodes}
            group={validGroup}
            page={this.props.page}
            size={this.props.size}
            sort={this.props.sort}
            order={this.props.order}
            per100g={validPer100g}
          />
        }

        <PrintDisclaimer />
      </div>
    );
  }
}

MultiNutrientSearch.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  code: PropTypes.string,
  group: PropTypes.string,
  page: PropTypes.number,
  size: PropTypes.number,
  sort: PropTypes.string,
  order: PropTypes.string,
  per100g: PropTypes.bool,
  componentFetch: PropTypes.instanceOf(PromiseState),
  groupFetch: PropTypes.instanceOf(PromiseState),
};

const fetch = () => ({
  //componentFetch: `${BASE_URL}/component`,
  componentFetch: `${BASE_URL}/component/set/name?set_name=All%20Components%20Ordered`,
  groupFetch: `${BASE_URL}/food/group`,
});

export default addUrlProps({ urlPropsQueryConfig })(connect(fetch)(MultiNutrientSearch));



// WEBPACK FOOTER //
// ./src/components/search/multiNutrient/MultiNutrientSearch.js